import { get, isEmpty, map } from 'lodash';
import { ApiResponse } from 'src/interfaces';

export interface IDyTemplate {
  id: number;
  template_name: string;
  name?: string;
  description?: string;
  configs?: any;
  number_of_variations?: number;
}

interface IDyTemplateApiItem {
  id: number;
  name: string;
  description?: string;
  config?: { name?: string };
  created_at?: string;
  modified_at?: string;
  number_of_variations?: number;
}

export const mapDyTemplates = (response: ApiResponse): IDyTemplate[] => {
  const data = (response?.data || []) as IDyTemplateApiItem[];

  if (isEmpty(data)) return [];

  return map(data, (item) => {
    const apiName = get(item, 'name', '');
    const configName = get(item, 'config.name', '');

    return {
      id: get(item, 'id'),
      template_name: apiName || configName || '',
      name: apiName,
      description: get(item, 'description', ''),
      configs: get(item, 'config'),
      number_of_variations: get(item, 'number_of_variations'),
    };
  });
};
